import InfiniteScroll from './InfiniteScroll.vue';

export default InfiniteScroll;
